export default {
  title: "Suscripción",
  description: "Gestiona tu plan y facturación",
  plans: {
    free: "Gratis",
    essential: "Esencial",
    pro: "Pro",
    premium: "Premium"
  },
  currentPlanMessage: {
    free: "Estás utilizando el plan Gratuito",
    pro: "¡Eres miembro Premium!"
  },
  eventsUsed: "Eventos utilizados",
  actions: {
    upgrade: "Mejorar plan",
    downgrade: "Reducir plan",
    cancel: "Cancelar suscripción",
    resume: "Reanudar suscripción",
    reactivate: "Reactivar suscripción"
  },
  status: {
    active: "Activa",
    canceled: "Cancelada",
    past_due: "Vencida"
  },
  featureRestricted: "Esta función requiere una suscripción",
  pageTitle: "Elige tu plan",
  pageDescription: "Selecciona el plan que mejor se adapte a tus necesidades",
  plan: {
    free: "Gratis",
    basic: "Básico",
    premium: "Premium",
    pro: "Pro",
    essential: "Esencial"
  },
  currentPlan: "Plan actual",
  mostPopular: "Más popular",
  choosePlan: "Elegir este plan",
  freePrice: "0€",
  essentialPrice: "15€/mes",
  proPrice: "30€/mes",
  freeDescription: "Perfecto para empezar",
  essentialDescription: "Para bodas clásicas",
  proDescription: "Para grandes eventos",
  unlimited: "Ilimitado",
  subscriptionUpdated: "Su suscripción se ha actualizado con éxito",
  updateError: "Error al actualizar su suscripción",
  usingBasicFeatures: "Uso de funciones básicas",
  limitReached: "Límite {{limit}} alcanzado ({{count}}/{{max}})",
  upgradeToIncreaseLimits: "Mejore su plan para aumentar estos límites",
  multipleEventsRestricted: "La gestión de múltiples eventos es limitada",
  upgradeToProForMultipleEvents: "Mejore a Pro para gestionar múltiples eventos",
  viewPlans: "Ver planes",
  upgradeToAccessPlan: "Actualice al plan {{plan}} para acceder a esta función",
  upgradeToAccessFeature: "Mejore a un plan superior para acceder a {{feature}}",
  features: {
    title: "Características",
    weddingWebsite: "Sitio web de boda",
    exportPDF: "Exportar PDF",
    exportExcel: "Exportar Excel",
    customDomain: "Dominio personalizado",
    adsRemoval: "Eliminación de anuncios",
    guestGroups: "Grupos de invitados",
    seatingPlanner: "Plano de asientos",
    budgetAnalytics: "Análisis de presupuesto",
    aiAssistant: "Asistente IA",
    customFields: "Campos personalizados",
    prioritySupport: "Soporte prioritario"
  },
  limits: {
    title: "Límites",
    maxGuests: "Invitados máximos",
    maxTasks: "Tareas máximas",
    maxVendors: "Proveedores máximos",
    maxCollaborators: "Colaboradores máximos"
  },
  faq: {
    title: "Preguntas frecuentes",
    question1: "¿Puedo cambiar de plan en cualquier momento?",
    answer1: "Sí, puedes mejorar o rebajar tu plan en cualquier momento. Los cambios surten efecto inmediatamente.",
    question2: "¿Hay cargos ocultos?",
    answer2: "No, todos nuestros precios son transparentes. No se cobrarán cargos adicionales.",
    question3: "¿Puedo cancelar en cualquier momento?",
    answer3: "Sí, puede cancelar su suscripción en cualquier momento. Mantendrá el acceso hasta el final de su período de facturación.",
    question4: "¿Ofrecen descuentos para estudiantes?",
    answer4: "Sí, ofrecemos un descuento del 20% para estudiantes. Contáctenos para más información.",
    multipleEventsQuestion: "¿Puedo gestionar múltiples eventos?",
    multipleEventsAnswer: "Con el plan Pro, puedes gestionar un número ilimitado de eventos. Los planes gratuito y esencial están limitados a un evento."
  },
  billing: {
    monthly: "Mensual",
    yearly: "Anual",
    save: "Ahorre {{percent}}%"
  },
  messages: {
    upgradeSuccess: "Tu plan ha sido actualizado con éxito",
    downgradeSuccess: "Tu plan ha sido rebajado con éxito",
    cancelSuccess: "Su suscripción ha sido cancelada",
    reactivateSuccess: "Su suscripción ha sido reactivada"
  }
,

  pageSubtitleNew: "Adapte WedBox a sus necesidades con nuestros planes flexibles",
  refreshBtn: "Actualizar",
  popular: "Popular",
  current: "Actual",
  freePlanBtn: "Plan gratuito",
  upgradeTo: "Cambiar a {{plan}}",
  currentPlanBtn: "Plan actual",
  usage: {
    events: "Gestión de eventos",
    guests: "Invitados",
    tasks: "Tareas",
    vendors: "Proveedores"
  },
  units: {
    events: "evento(s)",
    guests: "invitado(s)",
    tasks: "tarea(s)",
    vendors: "proveedor(es)"
  },
  checkout: {
    title: "Pago seguro",
    secureStripe: "Pago seguro con Stripe",
    cancelAnytime: "Puedes cancelar tu suscripción en cualquier momento desde tu cuenta.",
    lastRefresh: "Última actualización:",
    mustBeLoggedIn: "Debes iniciar sesión para proceder al pago",
    freeNoPayment: "El plan gratuito no requiere pago",
    creatingSession: "Creando sesión de pago...",
    redirecting: "Redirigiendo a Stripe...",
    subscribeTo: "Suscribirse al plan {{plan}}",
    cancel: "Cancelar",
    securePayment: "Pago seguro vía Stripe"
  },
  planDetails: {
    free: {
      name: "Gratis",
      price: "0€",
      description: "Perfecto para empezar",
      features: [
        "Gestionar 1 evento",
        "Hasta 50 invitados",
        "Máx 20 tareas",
        "10 proveedores",
        "Soporte comunitario"
      ]
    },
    essential: {
      name: "Esencial",
      price: "9€",
      description: "Para eventos importantes",
      features: [
        "Gestionar 3 eventos",
        "Hasta 200 invitados",
        "Tareas ilimitadas",
        "25 proveedores",
        "Exportación PDF/Excel",
        "Grupos de invitados",
        "Soporte prioritario"
      ]
    },
    pro: {
      name: "Pro",
      price: "19€",
      description: "Solución completa",
      features: [
        "Eventos ilimitados",
        "Invitados ilimitados",
        "Tareas ilimitadas",
        "Proveedores ilimitados",
        "Planificador de mesas",
        "Análisis avanzados",
        "Informes personalizados",
        "Soporte premium"
      ]
    }
  }

};
